import { API_URLS } from '../../../routes/urls';
import { apiSlice } from '../../apiSlice';
import { QueryErrorReturnValue } from '../../types';
import { addSnackbar } from '../snackbar/snackbarSlice';
import { RegisteredStatisticsResponse } from './types';

const registeredStatisticsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    registeredStatistics: builder.query<RegisteredStatisticsResponse, void>({
      query: () => ({
        url: API_URLS.registeredStatistics,
      }),
      async onQueryStarted(_args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          const err = error as QueryErrorReturnValue;
          dispatch(
            addSnackbar({
              severity: 'error',
              message: err.error.message,
            })
          );
        }
      },
    }),
  }),
});

export const { useRegisteredStatisticsQuery } = registeredStatisticsApi;
